<template>
  <footer class="cf-footer">
    <location-information
      v-if="isLocationDetailsDisplayed"
      :merchant="merchant"
      :selected-location="selectedLocation"
    />

    <template v-if="linkGroups">
      <custom-links
        v-for="group in linkGroups"
        :key="group.sortOrder"
        :group="group"
      />
    </template>

    <!-- <app-download-badges
      v-if="areMobileAppDownloadedDisplayed"
      class="spacing"
      :title="content.ReceiptStandard.metadata.appDownloadText"
    /> -->

    <card-free-branding v-if="isCardfreeBrandingDisplayed" />
  </footer>
</template>


<script>
  import { mapGetters } from 'vuex';

  import LocationInformation from './location-information/index.vue';
  import CustomLinks from './custom-links/index.vue';
  import CardFreeBranding from './card-free-branding/index.vue';


  export default {
    name: 'AppFooter',

    components: {
      LocationInformation,
      CustomLinks,
      CardFreeBranding
    },

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('locations', ['selectedLocation']),
      ...mapGetters('merchant', ['merchant']),

      isLocationDetailsDisplayed() {
        return !this.merchant.features['hide-footer-store-info'];
      },

      linkGroups() {
        return this.merchant.linkGroupsByType.Footer;
      },

      areMobileAppDownloadedDisplayed() {
        return Boolean((this.merchant.features.aosUrl || this.merchant.features.iosUrl) && this.merchant.options.showAppDownloadButtonsOnFooter);
      },

      isCardfreeBrandingDisplayed() {
        return this.merchant.features['cardfree-branding-placement'] !== 'None';
      }
    }
  };
</script>
